angular.module('admin.directives')
  .directive('inputFocus', ['$timeout', function ($timeout) {
    return {
      link: function (_scope, element, _attrs) {
        $timeout(() => {
          element[0].focus();
        });
      },
    };
  }]);
